import {LOCATION_CHANGED, PUSH, GO_BACK, GO, push, go, goBack} from 'redux-little-router';

const ACTIONS = {
    CHECK_FROM_LISTING_PAGE: 'ROUTER/CHECK_FROM_LISTING_PAGE',
    LOCATION_CHANGED,
    PUSH,
    GO_BACK,
    GO
};

const ACTION_CREATORS = {
    checkIfFromListingPage() {
        /* istanbul ignore next */
        return {
            type: ACTIONS.CHECK_FROM_LISTING_PAGE,
            payload: {}
        };
    },
    navigateTo: push,
    navigateBackTo() {
        // Limit how often this action can fire. See the limiterMiddleware
        // for more details.
        return {
            ...goBack(),
            meta: {
                limit: 1500
            }
        };
    },
    go
};

export default {...ACTIONS, ...ACTION_CREATORS};
